export default {
    getDashboardStatisticsBasic(state, data) {
        state.dashboardStatisticsBasic=data;
    },
};
